"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var authentication_1 = require("./authentication");
exports.authentication = authentication_1.authentication;
var populate_header_1 = require("./populate-header");
exports.populateHeader = populate_header_1.populateHeader;
//# sourceMappingURL=index.js.map